export default "__VITE_ASSET__CVmu97vI__"